import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
// import { UserModel } from 'app/services';
import { map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService
{
    private _httpClient = inject(HttpClient);
    private static _user: {id: string, email: string, roleId: number, roleName: string, customerId: string};

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: {id:string, email: string, roleId: number, roleName: string, customerId: string})
    {
        // Store the value
        UserService._user = value;
        localStorage.setItem('user', JSON.stringify(value));
    }

    get user(): {id:string, email: string, roleId: number, roleName: string, customerId: string}
    {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            UserService._user = JSON.parse(storedUser);
        }
        return UserService._user;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
}
